var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"link-outer"},[(_vm.href)?_c('nuxt-link',_vm._g(_vm._b({staticClass:"link link__icon-arrow",class:{
      'link__icon-arrow--back': _vm.back,
      'link__icon-arrow--next': _vm.next,
    },attrs:{"to":_vm.href}},'nuxt-link',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2):_vm._e(),_vm._v(" "),(!_vm.href)?_c('a',_vm._g(_vm._b({staticClass:"link link__icon-arrow",class:{
      'link__icon-arrow--back': _vm.back,
      'link__icon-arrow--next': _vm.next,
    },attrs:{"href":"javascript:void(0)"}},'a',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }